import coinBox from "assets/images/svg/refer-coin-box.svg";

function HeaderInfo() {
  return (
    <div className="flex flex-col items-center">
      <span className="coin-box-image">
        <img src={coinBox} alt="coin-box" />
      </span>
      <span className="font-title-normal leading-5 mt-4">
        Earn rewards & spread the happiness!
      </span>
      <p className="mt-1 font-body-normal leading-5 description">
        Know someone looking for their perfect match? Invite your friends to
        click4marry and and get rewarded! help them find their special someone!
      </p>
    </div>
  );
}

export default HeaderInfo;
